module.exports = __webpack_public_path__ + "img/s8RIcon.a7cb63c0.svg";